import { queryOptions } from '@tanstack/react-query'

import { GlobalParams } from '@/types/supports'

import { fetchGlobalParticipatedAds } from './methods'

const globalParticipatedAdQueryKeys = {
  all: ['globalParticipatedAds'] as const,
  list: (params: GlobalParams) => [...globalParticipatedAdQueryKeys.all, 'list', params] as const
}

export const globalParticipatedAdQueryOptions = {
  list: (params: GlobalParams) =>
    queryOptions({
      queryKey: globalParticipatedAdQueryKeys.list(params),
      queryFn: () => fetchGlobalParticipatedAds(params)
    })
}
